import styled from "styled-components";
import { Tabs } from "@libertify/ui";
import { STORYBOARD_MENU_TAB_HEIGHT } from "../constants";

export const StyledMenuTabs = styled(Tabs)`
  width: 100%;
  flex: 1;
  min-height: 0;

  .ant-tabs-tab {
    border-radius: 0 !important;
    border: none !important;
    height: ${STORYBOARD_MENU_TAB_HEIGHT}px;
    background-color: transparent !important;
    padding: 4px 8px !important;
    margin-right: 0;
  }

  .ant-tabs-tab-active {
    background-color: ${({ theme }) => theme.colorBgContainer} !important;
  }

  .ant-tabs-tab-btn {
    width: 100%;
    border: none;
    white-space: normal;
    text-align: center;
    font-weight: 300 !important;
  }

  .ant-tabs-content-holder {
    border-left: none;
    background-color: ${({ theme }) => theme.colorBgContainer};
    margin-left: 0;
    flex: 1;
    min-width: 0;
    padding: 0;
  }

  .ant-tabs-nav-operations {
    display: none !important;
  }
`;
